export default __webpack_public_path__ + "static/media/rating_4.c9bd3ab5.png";